import { gql } from '../types/generated';

export const BTC_PIPELINE_FRAGMENT = gql(`
  fragment BTCPipelineFields on MediaPipeline {
    id
    activeSlateCode
    feedType
    programSource
    pregameSource
    gameSource
    postgameSource
    status
    sourceSystem
    scheduledStartDateTime
    streamState
    resumedFromDateTime
    eviStatus
    eviPod {
      active
      vendor
      id
      name
    }
    media {
      id
      mediaType
      feedType
    }
    alerts {
      active
      clearedDateTime
      createdDateTime
      id
      message
    }
    regionalPipelines {
      id
      region
      status
      activeSlateCode
      activeSource
      eviStatus
      pregameSource
      gameSource
      postgameSource
      eviPod
      red5PreProcStreamName
      red5PostProcStreamName
      red5PrimaryHost
      red5BackupHost
      red5PrimaryNodeGroup
      red5BackupNodeGroup
      alerts {
        id
        active
        message
        clearedDateTime
        createdDateTime
      }
    }
  }
`);

/** Intentionally omits some fields so updates do not overwrite the Apollo cache when manually polling. */
export const BTC_PIPELINE_MEDIA_UPDATE_FRAGMENT = gql(`
  fragment BTCPipelineMediaUpdateFields on MediaPipeline {
    id
    activeSlateCode
    feedType
    status
    sourceSystem
    scheduledStartDateTime
    streamState
    resumedFromDateTime
    eviStatus
    eviPod {
      active
      vendor
      id
      name
    }
    media {
      id
      mediaType
      feedType
    }
    alerts {
      active
      clearedDateTime
      createdDateTime
      id
      message
    }
    regionalPipelines {
      id
      region
      status
      activeSlateCode
      activeSource
      eviStatus
      pregameSource
      gameSource
      postgameSource
      eviPod
      red5PreProcStreamName
      red5PostProcStreamName
      red5PrimaryHost
      red5BackupHost
      red5PrimaryNodeGroup
      red5BackupNodeGroup
      alerts {
        id
        active
        message
        clearedDateTime
        createdDateTime
      }
    }
  }
`);

export const BTC_CONTENT_FRAGMENT = gql(`
  fragment BTCContentFields on Content {
    callSign
    feedType
    gamePk
    mediaId
    language
    mediaState {
      contentExperience
      mediaType
      state
    }
  }
`);

export const BTC_CONTENT_ASSETS_FRAGMENT = gql(`
  fragment BTCContentAssetsFields on Content {
    callSign
    feedType
    gamePk
    mediaId
    language
    assets {
      adStatus
      assetId
      cdn
      path
      features
      provider
      state
      tier
      videoId
      playback {
        url
        cdn
        token
        expiration
        adsEnabled
        adExperienceType
        priority
        adEngineIdentifiers {
          name
          value
        }
      }
    }
    mediaState {
      contentExperience
      mediaType
      state
    }
  }
`);

export const BTC_BROADCAST_FRAGMENT = gql(`
  fragment BTCBroadcastFields on Broadcast {
    availability
    availableForStreaming
    callSign
    colorSpace
    feedType
    freeGameStatuses {
      freeGameType
      status
    }
    language
    mediaId
    mediaState
    mediaType
    mvpdRequired
    name
    postGameShow
    preGameShow
    videoResolution
  }
`);

export const BTC_GAME_FRAGMENT = gql(`
  fragment BTCGameFields on Game {
    away {
      ...TeamFields
    }
    home {
      ...TeamFields
    }
    venue {
      id
      name
    }
    features {
      featureType
      gameDate
      gamePk
      id
    }
    feeds {
      feedType
      postGameShow
      preGameShow
    }
    gameDate
    gamePk
    status
    broadcasts {
      ...BTCBroadcastFields
    }
    content {
      ...BTCContentFields
    }
    pipelines {
      ...BTCPipelineFields
    }
  }
`);

export const MULTICAST_MAPPING_FRAGMENT = gql(`
  fragment MulticastMappingFields on PipelineMulticastMapping {
    id
    callSign
    sourceLocation
    multicastAddress
    hdrMulticastAddress
    priority
    region
  }
`);

export const COPYRIGHT_STREAM_FRAGMENT = gql(`
  fragment CopyrightStreamFields on CopyrightStream {
    id
    gamePk
    homeTriCode
    awayTriCode
    scheduleDate
    feedType
    status
    gameStartTime
    streamStartTime
    streamEndTime
  }
`);
